// extracted by mini-css-extract-plugin
export default {"pagination-container":"CommonPagination_pagination-container__8g86n","active":"CommonPagination_active__8O5gJ"};